import React from 'react';
import { cardBackground, gradientColors } from '../../lib/utils';

/**
 * Selector de color de tarjeta — SIEMPRE degradado, de 2 o 3 colores.
 * El valor se guarda como "#c1,#c2" o "#c1,#c2,#c3" en el mismo campo de texto.
 * Si llega un color sólido, se deriva automáticamente a un degradado.
 */
export default function GradientColorPicker({ value, onChange }) {
  let cols = gradientColors(value, '#0A0A0A').filter((c) => /^#[0-9a-fA-F]{6}$/.test(c));
  if (cols.length < 2) cols = [cols[0] || '#0A0A0A', '#FFFFFF'];

  const emit = (arr) => onChange(arr.join(','));
  const setAt = (i, v) => { const a = [...cols]; a[i] = v; emit(a); };
  const addThird = () => emit([...cols.slice(0, 2), '#1A1A1A']);
  const removeThird = () => emit(cols.slice(0, 2));

  const swatch = (c, i) => (
    <label className="flex items-center gap-2" key={i}>
      <input
        type="color"
        value={/^#[0-9a-fA-F]{6}$/.test(c) ? c : '#0A0A0A'}
        onChange={(e) => setAt(i, e.target.value)}
        className="w-10 h-10 rounded-lg border border-gray-300 cursor-pointer bg-transparent"
      />
      <span className="text-gray-600 text-xs font-mono">{c}</span>
    </label>
  );

  return (
    <div className="space-y-3">
      <p className="text-xs text-gray-500">Degradado ({cols.length === 3 ? '3 colores' : '2 colores'})</p>

      <div className="flex items-center flex-wrap gap-3">
        {swatch(cols[0], 0)}
        <span className="text-gray-400">→</span>
        {swatch(cols[1], 1)}
        {cols.length === 3 && (
          <>
            <span className="text-gray-400">→</span>
            {swatch(cols[2], 2)}
          </>
        )}
      </div>

      <div>
        {cols.length < 3 ? (
          <button type="button" onClick={addThird}
            className="text-xs font-semibold text-black underline underline-offset-2 hover:text-gray-600">
            + Agregar 3er color
          </button>
        ) : (
          <button type="button" onClick={removeThird}
            className="text-xs font-semibold text-gray-500 underline underline-offset-2 hover:text-black">
            − Quitar 3er color
          </button>
        )}
      </div>

      {/* Vista previa */}
      <div
        className="w-full h-12 rounded-xl border border-gray-200"
        style={{ background: cardBackground(cols.join(',')) }}
      />
    </div>
  );
}
